exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list{padding:0!important}.post{background:#272727!important}#visibility{font-size:.7em!important;padding:1px 7px!important;margin-top:1px!important}", ""]);

// exports
